import React from 'react';
import './Load.css';

const LoaderPage = () => {
    return (
        <div className="loader-container">
         
            <div class="custom-loader"></div>     
        </div>
    );
};

export default LoaderPage;
